import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const CUES = [
  {
    number: 'CUE 1',
    title: 'Grip',
    text: 'Grip the bar as hard as you can. Thumb wrapped around, pressing into the middle and ring finger. An active grip creates tension that travels up your forearm and into your back.',
  },
  {
    number: 'CUE 2',
    title: 'Gaze',
    text: 'Look at the middle of the bar and keep your eyes on it before you pull. Focus on that area for the entire set. A fixed gaze creates a stable reference point so your mind can commit everything to performing an efficient and controlled pull-up.',
  },
  {
    number: 'CUE 3',
    title: 'Leg Position',
    text: 'Legs straight, squeezed together, core lightly engaged. Loose legs waste energy that should be going entirely into the pull.',
  },
  {
    number: 'CUE 4',
    title: 'Scapular Depression',
    text: 'Before your elbows bend, pull your shoulder blades down and back. Then drive your elbows toward your hips. This puts your lats in charge instead of your biceps.',
  },
  {
    number: 'CUE 5',
    title: 'Tempo and Range of Motion',
    text: 'Every rep starts from a dead hang — arms completely straight. Every rep ends with your chin above the bar. Lower yourself with control on the way down. This also builds pulling strength.',
  },
];

export default function FreeTechnique() {
  return (
    <div className="max-w-3xl" data-testid="free-technique-page">
      <h1 className="font-heading text-4xl sm:text-5xl font-black uppercase tracking-tight text-white leading-none mb-8">
        The 5 Pull-Up Cues
      </h1>

      <div className="space-y-4">
        {CUES.map((cue) => (
          <div key={cue.number} className="border border-mono-line bg-mono-card p-6 md:p-8" data-testid={`technique-cue-${cue.number.slice(-1)}`}>
            <p className="text-mono-mute font-heading text-xs font-bold uppercase tracking-[0.25em] mb-1">{cue.number}</p>
            <h2 className="font-heading text-lg font-bold uppercase tracking-wider text-white mb-3">{cue.title}</h2>
            <p className="text-white font-body leading-relaxed">{cue.text}</p>
          </div>
        ))}
      </div>

      <div className="mt-10 border-t border-mono-line pt-6" data-testid="free-technique-footer">
        <p className="text-white font-body">Want to see these cues in action?</p>
        <p className="text-mono-mute font-body text-sm mt-1 mb-5">
          I break all 5 down on video here — free, no signup, just the coaching.
        </p>
        <a
          href="https://youtu.be/faT9kL1pUZc"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 border border-crimson text-crimson hover:bg-crimson hover:text-white font-heading font-bold text-sm uppercase tracking-wider rounded-none px-5 py-2.5 transition-colors"
          data-testid="free-technique-video-link"
        >
          Watch the video <ArrowUpRight className="h-4 w-4" />
        </a>
      </div>
    </div>
  );
}
